import React, { FC } from "react";

import { useIntl } from "react-intl";

import ButtonLink from "@app/component/ButtonLink";
import { ClassName } from "@app/types/ui/ClassName";

import styles from "./GapSuggestion.module.scss";
import SuggestionProps from "./SuggestionProps";

const Span: FC<ClassName> = ({ children, className }) => (
  <span className={className}>{children}</span>
);

const GapSuggestion: React.FC<SuggestionProps> = () => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        {intl.formatMessage({
          id: "activities.calendarView.events.suggestion.gap.title",
          defaultMessage: "Looks like you have extra time today",
        })}{" "}
        <ButtonLink className={styles.link} tag={Span}>
          {intl.formatMessage({
            id: "activities.calendarView.events.suggestion.gap.action",
            defaultMessage: "Add an activity >",
          })}
        </ButtonLink>
      </div>
    </div>
  );
};

export default GapSuggestion;
